@if (selectedSignIntegration() != null) {
  <button
    type="button"
    class="btn btn-primary d-flex align-items-center gap-8"
    [class.btn-loading]="outerLoading || isLoading()"
    [disabled]="isDisabled || outerLoading || isLoading()"
    (click)="onSend($event)"
  >
    <span>{{ buttonText }}</span>
    <i class="icon ic-arrow-right-20"></i>
  </button>
} @else {
  <div
    ngbDropdown
    #connectionDropdown="ngbDropdown"
  >
    <button
      ngbDropdownToggle
      type="button"
      class="btn btn-primary d-flex align-items-center gap-8"
      [class.btn-loading]="isLoading()"
      [class.btn-primary-active]="connectionDropdown._open"
      [disabled]="isDisabled || isLoading()"
    >
      <span>{{ buttonText }}</span>
      <i class="icon ic-arrow-right-20"></i>
    </button>

    <div
      ngbDropdownMenu
      class="common-dropdown-menu select-connection-dropdown-menu"
    >
      <div class="select-connection-title color-gray-800 font-weight-bold">
        Choose E-Sign Method
      </div>

      <div class="select-connection-body d-flex flex-column">
        <app-disclaimer icon="" color="gray">
          <div class="d-flex gap-16">
            <i class="icon ic-info-circle-20 bg-gray-800"></i>

            <span class="font-size-14 line-height-20 font-weight-bold">
              {{ selectSignConnectionPlaceholder }}
            </span>
          </div>
        </app-disclaimer>

        <ul class="list-unstyled d-flex flex-column gap-8">
          @for (connection of eSignProviderConnections; track connection) {
            <li>
              <app-connection-card
                [connection]="connection"
                [isLoading]="isLoading()"
              />
            </li>
          }
        </ul>

      </div>
    </div>
  </div>
}
